<template>
 <div class="progress-bar default-theme">
  <div class="progress-bar__outer">
   <div class="progress-bar__inner" :style="barStyle"></div>
  </div>
 </div>
</template>
 
<script>
 export default {
  props:{
   color: {
    type: String,
    default: '#0090FF'
   },
   percent:{
    type: Number,
    default: 0,
    required: true,
    validator: val => val >= 0 && val <= 100
   }
  },
  computed:{
   barStyle() {
    const style = {};
    style.width = this.percent + '%';
    style.height = "4px";
    style.backgroundColor = this.color;
    return style;
   }
  }
 }
</script>
 
<style  scoped>
.progress-bar{
    width: 109px;
    height: 4px;
    background-color: #E2E5EC;
    border-radius: 2px;
    display: inline-block;
    margin-bottom: 2.5px;
    margin-right: 2px;
}

</style>